import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { ForwardIcon, BackIcon } from '../icons';

const styles = theme => ({
    link: {
        display: 'flex',
        alignItems: 'center',
    },
    backIcon: {
        marginRight: theme.spacing(1),
    },
    forwardIcon: {
        marginLeft: theme.spacing(1),
    },
    underline: {
        borderBottom: '1px solid',
    },
    text: {
        '$disabled &': {
            color: theme.palette.text.secondary,
            cursor: 'initial',
        },
    },
    white: {
        color: theme.palette.common.white,
    },
    disabled: {

    },
});

class VimoLink extends React.Component {
    render() {
        const {
            classes, to, text, className, backward, forward, white, disabled,
        } = this.props;

        return (
            <Link to={disabled ? '#' : to} className={classnames(classes.link, className, { [classes.disabled]: disabled })}>
                {backward && <BackIcon color="secondary" className={classnames(classes.backIcon, { [classes.white]: white })} />}
                <Typography className={classnames(classes.text, { [classes.white]: white })}>
                    <span className={classes.underline}>
                        {text}
                    </span>
                </Typography>
                {forward && <ForwardIcon color="secondary" className={classnames(classes.forwardIcon, { [classes.white]: white })} />}
            </Link>
        );
    }
}

VimoLink.propTypes = {
    classes: PropTypes.object.isRequired,
    to: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    backward: PropTypes.bool,
    forward: PropTypes.bool,
    white: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

VimoLink.defaultProps = {
    backward: false,
    forward: false,
    white: false,
    className: null,
    disabled: false,
};

export default withStyles(styles)(VimoLink);
